
import { IListNotificationsPayload, IListNotificationsResponse } from '../../Services/api/notifications/notifications.interface'
import { NotificationsApiRemoteService } from '../../Services/api/notifications/notifications-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


  export class ListNotificationsUseCase
implements IFormUsecase<IListNotificationsPayload, IListNotificationsResponse> {
  constructor (private readonly NotificationsApi: NotificationsApiRemoteService) {}
    

  public async handle (
    data: IListNotificationsPayload
  ): Promise<Result<IListNotificationsResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.NotificationsApi.list(data)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
